import request from '@/utils/request'

const urlPrefix = '/alerts/block-strategies'

export function getAlertBlockStrategy (id) {
  return request.get(`${urlPrefix}/${id}`)
}

export function updateAlertBlockStrategy (id, data) {
  return request.put(`${urlPrefix}/${id}`, data)
}

export function deleteAlertBlockStrategy (id) {
  return request.delete(`${urlPrefix}/${id}`)
}

export function getAlertBlockStrategyList (params) {
  return request.get(urlPrefix, { params })
}

export function createAlertBlockStrategy (data) {
  return request.post(urlPrefix, data)
}
